import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { StorageAutarkyDto } from 'src/Libs/storage/api/dto'
import { StorageAutarky } from 'src/Libs/storage/models/storage.models'
import { fromAutarkyDtoToModel } from 'src/Libs/storage/transformers/from-autarky-dto-to-model.transformer'
import { AuthFetchWithResponse } from 'src/Types/api'

/* get storage autarky values */
export const getStorageAutarkyValues = async (
  storageId: string | undefined,
  authFetch: AuthFetchWithResponse,
  from?: string,
  to?: string
): Promise<ApiResult<StorageAutarky, boolean>> => {
  if (!storageId) return new ApiResult<StorageAutarky, boolean>(null, false, false)
  try {
    const response = await authFetch<StorageAutarkyDto>({
      path: `storages/${storageId}/status/autarky`,
      payload: { from, to },
    })

    if (response.status === StatusCodes.OK) {
      const mappedResponse: StorageAutarky = fromAutarkyDtoToModel(response.data)
      return new ApiResult<StorageAutarky, boolean>(mappedResponse, false, false)
    }
    return new ApiResult<StorageAutarky, boolean>(null, false, false)
  } catch (error) {
    return new ApiResult<StorageAutarky, boolean>(null, true, false)
  }
}
